var cryptojs = require('crypto-js')

export default class CryptoService {
  CONFIG = {
    mode: cryptojs.mode.ECB,
    padding: cryptojs.pad.Pkcs7
  };

  encryptAES (message, key) {
    const toEncryptedArray = cryptojs.enc.Utf8.parse(message)
    const payload = cryptojs.AES.encrypt(toEncryptedArray, this.getKey(key), this.CONFIG)
    return payload.ciphertext.toString(cryptojs.enc.Base64)
  }

  decryptAES (message, key) {
    const toEncryptArray = cryptojs.enc.Base64.parse(message)
    const payload = cryptojs.AES.decrypt({ ciphertext: toEncryptArray }, this.getKey(key), this.CONFIG)
    return payload.toString(cryptojs.enc.Utf8)
  }


  getKey (key) {
    return cryptojs.enc.Hex.parse(cryptojs.MD5(key).toString())
  }

  
}
